import { UserBasic } from "src/app/_models/user.model";
import { Comment } from "../../_component/comment/comment.model";
import { Report } from "../report.model";

export class ReportTask {
  id: number;
  idReport: number;
  description: string;
  status: number;
  performedBy: UserBasic = new UserBasic(); //osoba wykonujaca zadanie
  assignmentBy: UserBasic = new UserBasic(); //osoba zlecajaca zadanie -- domyslnie z loginu
  idUserAssignmentBy: number;
  idUserPerformedBy: number;
  createdAt: Date;
  changedAt: Date;
  endedAt: Date;
  comments: Comment[];
  report: Report;
}
